import { UpdateBillingCycleResponseSchema } from '@weft/api-definition';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { UpdateBillingCycleRequest } from './use-update-billing-cycle-types/update-billing-cycle-request';

export function useUpdateBillingCycle() {
  return useMutation(async (updateBillingCycleOperationRequest: UpdateBillingCycleRequest) => {
    const api = getPrivateApi();
    const updateBillingCycleResponse = await api.updateBillingCycle(updateBillingCycleOperationRequest);

    return UpdateBillingCycleResponseSchema.parse(updateBillingCycleResponse);
  });
}